










































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

interface TabItem {
  label: string;
}

export default Vue.extend({
  name: 'TabMenu',
  props: {
    initialActiveTab: {
      type: Number as PropType<number>,
      default: 0
    }
  },
  data () {
    return {
      activeTabIndex: this.initialActiveTab,
      tabs: [
        { label: 'Distribution of Groups' },
        { label: 'Baseline LNOB Tree' },
        { label: 'Shifts between Groups' },
        { label: 'Inequality Analysis' },
        { label: 'Inequality Metrics' },
        { label: 'Cost Analysis' }
      ] as TabItem[]
    };
  },
  watch: {
    initialActiveTab: {
      handler: function () {
        this.activeTabIndex = this.initialActiveTab;
      }
    }
  },
  computed: {
    ...mapGetters('analysis', [
      'getSp2lnobConfigs'
    ])
  },
  methods: {
    ...mapActions('analysis', [
      'updateSp2lnobConfigs'
    ]),
    handleTabClick (index: number): void {
      this.activeTabIndex = index;
      const updateObj = {
        activeTab: index
      };
      this.updateSp2lnobConfigs({
        ...this.getSp2lnobConfigs,
        ...updateObj
      });
    }
  }
});
